import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import DocumentsTable from "../../../../shared/components/DocumentsTable";

export default class TaskDocumentsModal extends React.Component {

  render() {

    return (
      <Modal
        {...this.props}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {this.props.title}<br/>
            <small>{this.props.date}</small><br/>
            <small>{this.props.build}</small><br/>
            <small>{this.props.subtitle}</small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DocumentsTable
            data={this.props.data}
            error={this.props.error}
            hideOutsource={true}
          />
        </Modal.Body>
      </Modal>
    );
  }
}


TaskDocumentsModal.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  build: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  data: PropTypes.any,
  error: PropTypes.string,
  onHide: PropTypes.func,
};

TaskDocumentsModal.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/components/TaskDocumentsModal.js